export default __webpack_public_path__ + "static/media/admin.963e7e65.png";